export function single<T>(array: (T | null | undefined)[] | undefined): T {
  const result = array?.length === 1 ? array[0] : undefined

  if (result === undefined || result === null) {
    throw new Error('The array does not have exactly one item')
  }

  return result
}
